import { Component, Input, OnChanges } from '@angular/core';
import { FunnelBarVm } from '../../../../domain/model/pipeline-health.model';
import { NO_VALUE_LABEL } from '../../../../shared/pipeline-funnel.helper';

/** One funnel row: stage label, the proportional track with its count, the percentage and the aging chip. */
@Component({
  selector: 'ifbp-pipeline-funnel-bar',
  templateUrl: './pipeline-funnel-bar.component.html',
  styleUrls: ['./pipeline-funnel-bar.component.scss'],
  standalone: false,
})
export class PipelineFunnelBarComponent implements OnChanges {
  @Input() vm: FunnelBarVm;
  /** An empty bar draws no track, so its count is rendered beside the track instead of inside it. */
  countInside = false;
  /** A zero-width track must drop its padding, or the padding box still paints a stage-coloured block. */
  trackEmpty = true;
  /** The design reads "34% of started"; the empty-cohort dash carries no suffix. */
  showPercentSuffix = false;

  ngOnChanges(): void {
    this.countInside = (this.vm?.count ?? 0) > 0;
    this.trackEmpty = (this.vm?.widthPercent ?? 0) <= 0;
    this.showPercentSuffix = !!this.vm && this.vm.percentLabel !== NO_VALUE_LABEL;
  }
}
